import { RootState } from "@/app/stores"
import { createInvitation, deleteInvitation, ICreateInvitation, IInvitation, LinkType } from "@/shared/api/invitations"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

interface CreateInvitationPayload {
    data: ICreateInvitation,
    type: LinkType
}

export const fetchCreateInvitation = createAsyncThunk<
    IInvitation,
    CreateInvitationPayload,
    { state: RootState}
>(`updateInvitation/fetchCreateInvitation`, async(data, thunkAPI) => {
    try {
        const response = await createInvitation(data.type, data.data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDeleteInvitation = createAsyncThunk<
    IInvitation,
    void,
    { state: RootState}
>(`updateInvitation/fetchDeleteInvitation`, async(_, thunkAPI) => {
    try {
        const { currentInvitation } = thunkAPI.getState().updateInvitation
        const response = await deleteInvitation(currentInvitation.id)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})